import { useState } from 'react'
import TableTab2 from "./TableTab2";
import {
  useItemWarehouseCheckInListMutation,
  useItemCompanyMutation,
  usePriceDetailsListMutation
} from "../../../../store/api/itemapi";
const Tab2 = ({ setselected_default_item_data,company_list_data,warehouse_list_data,price_list}) => {
   const [ItemCompanyApi] = useItemCompanyMutation();
   const [WarehouseApi] = useItemWarehouseCheckInListMutation();
   const [PriceListApi] = usePriceDetailsListMutation();
  return (
   <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Defaults</p>
      </div>
      
      
      
      <TableTab2 setselected_default_item_data={setselected_default_item_data} company_list_data={ItemCompanyApi} warehouse_list_data={WarehouseApi} price_list={PriceListApi}/>


    </div>
  )
}

export default Tab2